/* AllMaleUp production runtime — reimplements the Claude Design dc-runtime handlers
   against the real rendered markup (amu-acc, data-menu-btn, #amu-journal-rail, amu-sticky). */
(function(){
  'use strict';
  var d=document;

  // --- FAQ accordion (CSS shows/hides .amu-acc-panel + rotates chevron via [aria-expanded]) ---
  d.querySelectorAll('.amu-acc').forEach(function(acc){
    acc.querySelectorAll('.amu-acc-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        var wasOpen=btn.getAttribute('aria-expanded')==='true';
        acc.querySelectorAll('.amu-acc-btn').forEach(function(b){b.setAttribute('aria-expanded','false');});
        btn.setAttribute('aria-expanded', wasOpen?'false':'true');
      });
    });
  });

  // --- Journal carousel arrows ---
  var rail=d.getElementById('amu-journal-rail');
  if(rail){
    d.querySelectorAll('button[aria-label]').forEach(function(b){
      var lbl=(b.getAttribute('aria-label')||'').toLowerCase();
      if(lbl.indexOf('journal')<0) return;
      var back=lbl.indexOf('back')>=0||lbl.indexOf('prev')>=0;
      b.addEventListener('click',function(){rail.scrollBy({left:back?-380:380,behavior:'smooth'});});
    });
  }

  // --- Pack purchase toggle (One-time vs Subscribe): mirror aria-pressed across the pair ---
  var toggles=[...d.querySelectorAll('button[aria-pressed]')].filter(function(b){
    var t=(b.innerText||'').toLowerCase(); return t.indexOf('one-time')>=0||t.indexOf('subscribe')>=0;
  });
  toggles.forEach(function(b){
    b.addEventListener('click',function(){
      toggles.forEach(function(x){x.setAttribute('aria-pressed', x===b?'true':'false');});
    });
  });

  // --- Mobile nav drawer: built on first open from the primary nav links ---
  var menuBtn=d.querySelector('[data-menu-btn]');
  if(menuBtn){
    var drawer=null, open=false;
    var build=function(){
      var nav=d.querySelector('nav[aria-label="Primary"]');
      drawer=d.createElement('div');
      drawer.setAttribute('role','dialog');
      drawer.setAttribute('aria-label','Menu');
      drawer.style.cssText='position:fixed;inset:0;z-index:100;background:rgba(8,20,43,.55);display:none';
      var panel=d.createElement('nav');
      panel.style.cssText='position:absolute;left:0;top:0;bottom:0;width:min(84vw,340px);background:#FAF7F2;box-shadow:0 8px 24px rgba(0,0,0,.25);padding:20px 22px;display:flex;flex-direction:column;gap:6px;overflow:auto';
      var links=nav?[...nav.querySelectorAll('a')]:[];
      var cls=d.querySelector('a[data-cta-top]');
      var html='<button aria-label="Close menu" style="align-self:flex-end;border:0;background:transparent;font:700 22px/1 Inter;cursor:pointer;color:#14181E;padding:6px 4px 12px">×</button>';
      links.forEach(function(a){html+='<a href="'+a.getAttribute('href')+'" style="font:600 18px/1.4 Inter;color:#14181E;text-decoration:none;padding:12px 4px;border-bottom:1px solid #E5E0D7">'+a.textContent.trim()+'</a>';});
      if(cls)html+='<a href="'+cls.getAttribute('href')+'" style="margin-top:14px;background:#018255;color:#fff;border-radius:999px;padding:14px;text-align:center;font:600 16px/1 Inter;text-decoration:none">'+cls.textContent.trim()+'</a>';
      panel.innerHTML=html;
      drawer.appendChild(panel);
      d.body.appendChild(drawer);
      drawer.addEventListener('click',function(e){if(e.target===drawer)toggle(false);});
      panel.querySelector('button').addEventListener('click',function(){toggle(false);});
      panel.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){toggle(false);});});
    };
    var toggle=function(v){
      if(!drawer)build();
      open=(v==null)?!open:v;
      drawer.style.display=open?'block':'none';
      menuBtn.setAttribute('aria-expanded',open);
      d.documentElement.style.overflow=open?'hidden':'';
    };
    menuBtn.addEventListener('click',function(){toggle();});
  }

  // --- Sticky purchase bar: pin + reveal after the hero ---
  var sticky=d.querySelector('.amu-sticky');
  if(sticky && !sticky.classList.contains('amu-sticky-fixed')){
    sticky.classList.add('amu-sticky-fixed');
    sticky.style.transition='transform .32s cubic-bezier(.2,0,0,1)';
    var anchor=d.querySelector('header');
    var reveal=function(){var y=window.scrollY||0;var h=anchor?anchor.offsetHeight+560:600;var on=y>h;sticky.style.transform=on?'translateY(0)':'translateY(110%)';};
    window.addEventListener('scroll',reveal,{passive:true}); reveal();
  }
})();

/* AMU packs + subscribe */
(function(){
  var d=document;
  var money=function(c){return '£'+(c/100).toFixed(2);};
  var packs=d.querySelector('[data-amu-packs]');
  if(!packs) return;
  var cards=[].slice.call(packs.querySelectorAll('[data-amu-card]'));
  var modes=[].slice.call(packs.querySelectorAll('[data-amu-mode]'));
  var freqWrap=packs.querySelector('[data-amu-freq-wrap]');
  var freq=packs.querySelector('[data-amu-freq]');
  var note=packs.querySelector('[data-amu-sub-note]');

  var plansOf=function(card){
    try{ return JSON.parse(card.getAttribute('data-plans')||'[]'); }catch(e){ return []; }
  };
  var months=[];
  cards.forEach(function(c){ plansOf(c).forEach(function(p){ if(months.indexOf(p.months)<0) months.push(p.months); }); });
  months.sort(function(a,b){return a-b;});
  if(freq){
    freq.innerHTML = months.map(function(m){
      return '<option value="'+m+'">'+(m===1?'month':m+' months')+'</option>';
    }).join('');
  }
  // no plans -> hide the subscribe option entirely
  if(!months.length) modes.forEach(function(b){ if(b.getAttribute('data-amu-mode')==='subscribe') b.style.display='none'; });

  var subOn=function(){
    var b=modes.filter(function(x){return x.getAttribute('data-amu-mode')==='subscribe';})[0];
    return b && b.getAttribute('aria-pressed')==='true';
  };
  var paintModes=function(){
    modes.forEach(function(b){
      var on=b.getAttribute('aria-pressed')==='true';
      // unselected "Subscribe & save 15%" keeps a soft green tint so the cheaper
      // option is noticeable without being pre-selected for the customer
      var isSub=b.getAttribute('data-amu-mode')==='subscribe';
      b.style.background = on ? '#FFFFFF' : (isSub ? 'rgba(1,130,85,.12)' : 'transparent');
      b.style.color      = on ? '#14181E' : '#016A45';
      b.style.boxShadow  = on ? '0 1px 2px rgba(20,24,30,.06)' : 'none';
    });
  };

  var render=function(){
    var on=subOn();
    var m=freq&&freq.value?parseInt(freq.value,10):months[0];
    if(freqWrap){ freqWrap.hidden=!on; freqWrap.style.display=on?'inline-flex':'none'; }
    if(note){ note.hidden=!on; note.style.display=on?'block':'none'; }
    paintModes();
    cards.forEach(function(card){
      var base=parseInt(card.getAttribute('data-price'),10);
      var tablets=parseFloat(card.getAttribute('data-tablets'))||0;
      var plan=null;
      if(on){ plansOf(card).forEach(function(p){ if(p.months===m) plan=p; }); }
      var price=plan?plan.price:base;
      var priceEl=card.querySelector('[data-amu-price]');
      var cmpEl=card.querySelector('[data-amu-compare]');
      var perEl=card.querySelector('[data-amu-per]');
      var saveEl=card.querySelector('[data-amu-save]');
      var btn=card.querySelector('[data-amu-buy]');
      if(priceEl) priceEl.textContent=money(price);
      if(cmpEl){
        var show=plan&&plan.price<base;
        cmpEl.hidden=!show; cmpEl.style.display=show?'inline':'none';
        cmpEl.textContent=show?money(base):'';
      }
      if(perEl&&tablets) perEl.textContent=money(price/tablets)+' per tablet';
      if(saveEl) saveEl.textContent = plan&&plan.price<base ? 'Save '+money(base-plan.price)+' per pack vs one-time' : '';
      if(btn){
        btn.textContent='Buy now — '+money(price);
        btn.setAttribute('data-plan', plan?plan.id:'');
      }
    });
  };

  modes.forEach(function(b){
    b.addEventListener('click',function(){
      modes.forEach(function(x){ x.setAttribute('aria-pressed', x===b?'true':'false'); });
      render();
    });
  });
  if(freq) freq.addEventListener('change',render);
  render();

  cards.forEach(function(card){
    var btn=card.querySelector('[data-amu-buy]');
    if(!btn) return;
    btn.addEventListener('click',function(){
      var id=parseInt(card.getAttribute('data-variant'),10);
      if(!id) return;
      var plan=btn.getAttribute('data-plan');
      var item={id:id,quantity:1};
      if(plan) item.selling_plan=parseInt(plan,10);
      var label=btn.textContent;
      btn.disabled=true; btn.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item]})})
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok,j:j}; }); })
      .then(function(res){
        if(res.ok){ window.location.href='/checkout'; return; }
        btn.disabled=false; btn.textContent=label;
        alert((res.j&&(res.j.description||res.j.message))||'Sorry, this pack could not be added right now.');
      })
      .catch(function(){ btn.disabled=false; btn.textContent=label; });
    });
  });
})();

/* AMU PDP subscribe */
(function(){
  var d=document;
  var wrap=d.querySelector('[data-amu-pdp-sub]');
  if(!wrap) return;
  var money=function(c){return '£'+(c/100).toFixed(2);};
  var base=parseInt(wrap.getAttribute('data-price'),10);
  var plans=[]; try{ plans=JSON.parse(wrap.getAttribute('data-plans')||'[]'); }catch(e){}
  plans.sort(function(a,b){return a.months-b.months;});
  var chk=wrap.querySelector('[data-amu-pdp-toggle]');
  var fw=wrap.querySelector('[data-amu-pdp-freq-wrap]');
  var sel=wrap.querySelector('[data-amu-pdp-freq]');
  var note=wrap.querySelector('[data-amu-pdp-note]');
  var priceEl=d.querySelector('[data-amu-pdp-price]');
  var cmpEl=d.querySelector('[data-amu-pdp-compare]');
  var perTabEl=d.querySelector('[data-amu-pdp-pertab]');
  var tabCount=perTabEl?parseInt(perTabEl.getAttribute('data-tablets'),10):0;
  var planInput=d.querySelector('[data-amu-pdp-plan]');
  if(sel) sel.innerHTML=plans.map(function(p){
    return '<option value="'+p.id+'" data-price="'+p.price+'">'+(p.months===1?'month':p.months+' months')+'</option>';
  }).join('');
  var render=function(){
    var on=chk&&chk.checked;
    if(fw){ fw.hidden=!on; fw.style.display=on?'inline-flex':'none'; }
    if(note){ note.hidden=!on; note.style.display=on?'block':'none'; }
    var cur=null;
    if(on&&sel){ var id=parseInt(sel.value,10); plans.forEach(function(p){ if(p.id===id) cur=p; }); }
    var price=cur?cur.price:base;
    if(priceEl) priceEl.textContent=money(price);
    if(cmpEl){ var show=cur&&cur.price<base; cmpEl.hidden=!show; cmpEl.style.display=show?'inline':'none'; cmpEl.textContent=show?money(base):''; }
    // the £/tablet line is static Liquid, so it has to follow the subscription price
    if(perTabEl&&tabCount>0){ perTabEl.textContent='£'+(price/100/tabCount).toFixed(2)+' per tablet'; }
    if(planInput){
      if(cur){ planInput.value=cur.id; planInput.disabled=false; }
      else { planInput.value=''; planInput.disabled=true; }
    }
  };
  if(chk) chk.addEventListener('change',render);
  if(sel) sel.addEventListener('change',render);
  render();
})();

/* AMU PDP gallery */
(function(){
  var d=document;
  var gal=d.querySelector('[data-amu-gallery]');
  if(!gal) return;
  var main=gal.querySelector('[data-amu-gal-main]');
  var counter=gal.querySelector('[data-amu-gal-counter]');
  var thumbs=[].slice.call(d.querySelectorAll('[data-amu-gal-thumb]'));
  var srcs=thumbs.map(function(b){return b.getAttribute('data-src');});
  var sets=thumbs.map(function(b){return b.getAttribute('data-srcset')||'';});
  if(!srcs.length && main) srcs=[main.getAttribute('src')];
  var i=0;
  var paint=function(){
    if(main&&srcs[i]){
      // srcset wins over src, so it must be swapped too (or cleared)
      if(sets[i]) main.setAttribute('srcset',sets[i]); else main.removeAttribute('srcset');
      main.setAttribute('src',srcs[i]);
    }
    if(counter) counter.textContent=(i+1)+' / '+srcs.length;
    thumbs.forEach(function(b,n){
      b.style.outline = n===i ? '2px solid #018255' : 'none';
      b.style.outlineOffset = '2px';
      b.setAttribute('aria-current', n===i ? 'true' : 'false');
    });
  };
  var go=function(n){ i=(n+srcs.length)%srcs.length; paint(); };
  var prev=gal.querySelector('[data-amu-gal-prev]');
  var next=gal.querySelector('[data-amu-gal-next]');
  if(prev) prev.addEventListener('click',function(){go(i-1);});
  if(next) next.addEventListener('click',function(){go(i+1);});
  thumbs.forEach(function(b,n){ b.addEventListener('click',function(){go(n);}); });
  gal.setAttribute('tabindex','0');
  gal.addEventListener('keydown',function(e){
    if(e.key==='ArrowLeft'){e.preventDefault();go(i-1);}
    if(e.key==='ArrowRight'){e.preventDefault();go(i+1);}
  });
  paint();
})();

/* AMU PDP quantity stepper — the markup shipped without a controller, so − and +
   were dead and the hidden quantity field never left 1. */
(function(){
  var d=document;
  var input=d.querySelector('[data-qty-input]');
  var disp=d.querySelector('[data-qty-display]');
  var minus=d.querySelector('[data-qty-minus]');
  var plus=d.querySelector('[data-qty-plus]');
  if(!input||!minus||!plus) return;
  var MAX=99;
  var n=parseInt(input.value,10)||1;
  var render=function(){
    if(n<1) n=1; if(n>MAX) n=MAX;
    input.value=String(n);
    if(disp) disp.textContent=String(n);
    minus.disabled = n<=1;
    plus.disabled = n>=MAX;
  };
  minus.addEventListener('click',function(){ n--; render(); });
  plus.addEventListener('click',function(){ n++; render(); });
  render();
})();

/* AMU PDP straight-to-checkout */
(function(){
  var form=document.getElementById('amu-product-form');
  if(!form) return;
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var btn=form.querySelector('button[type="submit"]');
    var label=btn?btn.textContent:'';
    if(btn){ btn.disabled=true; btn.textContent='Adding…'; }
    var fd=new FormData(form);
    var item={ id:parseInt(fd.get('id'),10), quantity:parseInt(fd.get('quantity')||'1',10) };
    var plan=fd.get('selling_plan');
    if(plan) item.selling_plan=parseInt(plan,10);
    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item]})})
    .then(function(r){ return r.json().then(function(j){ return {ok:r.ok,j:j}; }); })
    .then(function(res){
      if(res.ok){ window.location.href='/checkout'; return; }
      if(btn){ btn.disabled=false; btn.textContent=label; }
      alert((res.j&&(res.j.description||res.j.message))||'Sorry, this pack could not be added right now.');
    })
    .catch(function(){ if(btn){ btn.disabled=false; btn.textContent=label; } });
  });
})();

/* AMU styled dropdown — a native <select> popup is drawn by the OS and cannot be
   styled, so mirror it with a listbox. The <select> stays in the DOM as the source
   of truth (the packs code reads .value and listens for 'change'); it is hidden from
   sight and from assistive tech, which read the listbox instead.
   Runs last, after the packs and PDP blocks have filled in their <option>s. */
(function(){
if(!document.createElement('div').closest) return;
var upgrade=function(sel){
  if(!sel||!sel.options.length||sel.dataset.amuUpgraded) return;
  sel.dataset.amuUpgraded='1';

  var wrap=document.createElement('div');
  wrap.className='amu-sel';
  var btn=document.createElement('button');
  btn.type='button';
  btn.className='amu-sel-btn';
  btn.setAttribute('aria-haspopup','listbox');
  btn.setAttribute('aria-expanded','false');
  // borrow the visible "Deliver every" label so the button is not just announced as "month"
  var lab=sel.id?document.querySelector('label[for="'+sel.id+'"]'):null;
  if(lab){ if(!lab.id) lab.id=sel.id+'-label'; btn.setAttribute('aria-labelledby',lab.id); }
  var caption=document.createElement('span');
  btn.appendChild(caption);
  btn.insertAdjacentHTML('beforeend','<svg class="amu-sel-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"></path></svg>');

  var list=document.createElement('ul');
  list.className='amu-sel-list';
  list.setAttribute('role','listbox');
  list.hidden=true;

  var items=[].map.call(sel.options,function(o,i){
    var li=document.createElement('li');
    li.setAttribute('role','option');
    li.tabIndex=-1;
    li.innerHTML='<span class="amu-sel-tick" aria-hidden="true">✓</span>';
    li.appendChild(document.createTextNode(o.text));
    li.addEventListener('click',function(){ pick(i); });
    list.appendChild(li);
    return li;
  });

  var paint=function(){
    caption.textContent=sel.options[sel.selectedIndex].text;
    items.forEach(function(li,i){ li.setAttribute('aria-selected',i===sel.selectedIndex?'true':'false'); });
  };
  var open=function(){
    list.hidden=false; btn.setAttribute('aria-expanded','true');
    (items[sel.selectedIndex]||items[0]).focus();
  };
  var close=function(back){
    list.hidden=true; btn.setAttribute('aria-expanded','false');
    if(back) btn.focus();
  };
  var pick=function(i){
    sel.selectedIndex=i;
    sel.dispatchEvent(new Event('change',{bubbles:true}));
    paint(); close(true);
  };

  btn.addEventListener('click',function(){ list.hidden?open():close(true); });
  btn.addEventListener('keydown',function(e){
    if(e.key==='ArrowDown'||e.key==='ArrowUp'||e.key==='Enter'||e.key===' '){ e.preventDefault(); open(); }
  });
  list.addEventListener('keydown',function(e){
    var cur=items.indexOf(document.activeElement); if(cur<0) cur=sel.selectedIndex;
    if(e.key==='ArrowDown'){ e.preventDefault(); items[Math.min(cur+1,items.length-1)].focus(); }
    else if(e.key==='ArrowUp'){ e.preventDefault(); items[Math.max(cur-1,0)].focus(); }
    else if(e.key==='Home'){ e.preventDefault(); items[0].focus(); }
    else if(e.key==='End'){ e.preventDefault(); items[items.length-1].focus(); }
    else if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pick(cur); }
    else if(e.key==='Escape'||e.key==='Tab'){ close(e.key==='Escape'); }
  });
  document.addEventListener('mousedown',function(e){ if(!list.hidden&&!wrap.contains(e.target)) close(false); });

  sel.className=(sel.className?sel.className+' ':'')+'amu-sel-native';
  sel.setAttribute('aria-hidden','true');
  sel.tabIndex=-1;
  wrap.appendChild(btn); wrap.appendChild(list);
  sel.parentNode.insertBefore(wrap,sel.nextSibling);
  paint();
  // the packs/PDP code may re-select a month itself (e.g. on mode switch)
  sel.addEventListener('change',paint);
};
// homepage packs and the PDP subscribe row both use one of these
[].forEach.call(document.querySelectorAll('[data-amu-freq],[data-amu-pdp-freq]'),upgrade);
})();
